import { render, staticRenderFns } from "./AppSwitchSiteModal.vue?vue&type=template&id=6ad72845&scoped=true"
import script from "./AppSwitchSiteModal.vue?vue&type=script&lang=js"
export * from "./AppSwitchSiteModal.vue?vue&type=script&lang=js"
import style0 from "./AppSwitchSiteModal.vue?vue&type=style&index=0&id=6ad72845&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad72845",
  null
  
)

export default component.exports